import { createResource, createRoot, createSignal } from 'solid-js'
import { useCompany } from '~/contexts/CompanyContext'
import { companyService } from '~/services/company.service'
import type { CompanySettingsType } from '~/types/Settings'
import { mergeSettings } from '~/utils/settings'

/**
 * Settings de la empresa activa, cargados una vez y compartidos entre páginas.
 * En vez de que cada pantalla haga `companyService.get()` por su cuenta, este
 * recurso de módulo centraliza la petición: monedas, tipos de documento,
 * estados, formato de números/fechas... todo sale de aquí.
 *
 * Se recarga cuando cambia `companyId` (al cambiar de empresa).
 */

const { companyId, setCompanyId, settings, refetch } = createRoot(() => {
  const [companyId, setCompanyId] = createSignal<string | null>(null)
  const [settings, { refetch }] = createResource(companyId, async (id: string) => {
    try {
      const data = await companyService.get(id)
      return mergeSettings((data.settings ?? {}) as Partial<CompanySettingsType>)
    } catch {
      return mergeSettings({})
    }
  })
  return { companyId, setCompanyId, settings, refetch }
})

export function useCompanySettings() {
  const { currentCompany } = useCompany()
  const id = currentCompany().id
  if (id !== companyId()) setCompanyId(id)

  return { settings, loading: settings.loading, refetch }
}
